import {Help} from './help';

export default {
    component: Help
};
